import { Node, mergeAttributes } from '@tiptap/core';

export interface TabOptions {
  HTMLAttributes: Record<string, any>;
}

export const Tab = Node.create<TabOptions>({
  name: 'tab',
  content: 'block+',
  defining: true,
  isolating: true,
  selectable: false,

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  addAttributes() {
    return {
      label: {
        default: 'Tab',
        parseHTML: (el) => el.getAttribute('data-label') || 'Tab',
        renderHTML: (attrs) => ({ 'data-label': attrs.label }),
      },
      // Icon shown next to the label in the public tab strip. Two forms,
      // matching how group pages and pinned sidebar links already store
      // theirs: `licon:<key>` picks a bundled icon (the curated glyph set,
      // or a brand mark under apps/public/public/brand), anything else is
      // treated as an uploaded attachment path.
      //
      // The attribute has to exist here even though the admin has no picker
      // for it yet: ProseMirror drops attrs a node type does not declare, so
      // without this the editor would silently strip every icon the moment
      // someone opened the page.
      icon: {
        default: null,
        parseHTML: (el) => el.getAttribute('data-icon') || null,
        renderHTML: (attrs) => (attrs.icon ? { 'data-icon': attrs.icon } : {}),
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="tab"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(
        { 'data-type': this.name },
        this.options.HTMLAttributes,
        HTMLAttributes,
      ),
      0,
    ];
  },
});
